import { useLastMinuteOffer } from "@/components/promotions/last-minute-offer";
/** Undated reference rate; discounts require an actual eligible stay. */
export function rateParts(home: { base_rate?: string | null; regular_rate?: string | null }) {
  const value = Number(home.base_rate);
  return {rate: Number.isFinite(value) && value > 0 ? value : null, promo: null};
}

export function RateLine({
  home,
  className = "",
  size = "md",
  testId,
}: {
  home: { slug?: string | null; base_rate?: string | null; regular_rate?: string | null };
  className?: string;
  size?: "sm" | "md";
  testId?: string;
}) {
  const {data: offer, isLoading, isError} = useLastMinuteOffer(home.slug);
  const stay = !isLoading && !isError && offer?.active && offer.propertySlug === home.slug ? offer.windows?.find(w => Number.isFinite(w.nightlyRate) && w.nightlyRate > 0 && Number.isFinite(w.regularNightlyRate) && w.regularNightlyRate > w.nightlyRate) : undefined;
  const base = rateParts(home);
  const { rate, promo } = stay ? {rate: stay.regularNightlyRate, promo: stay.nightlyRate} : base;
  if (!rate) return <p className={className}>Choose dates for pricing</p>;
  const big = size === "md" ? "text-xl" : "text-base md:text-lg";
  const small = size === "md" ? "text-base" : "text-sm md:text-base";
  return (
    <p className={`font-sans text-luxury-sm text-ink/70 ${className}`} data-testid={testId}>
      {stay ? "Last-minute offer" : "Indicative rate"}{" "}
      {promo ? (
        <>
          <s className={`font-serif ${small} text-driftwood decoration-1`}>${rate.toLocaleString("en-US")}</s>{" "}
          <span className={`font-serif ${big} text-ink`}>${promo.toLocaleString("en-US")}</span>
        </>
      ) : (
        <span className={`font-serif ${big} text-ink`}>${rate.toLocaleString("en-US")}</span>
      )}{" "}
      / night · USD
      <span className="mt-1 block text-xs">Before taxes &amp; fees{stay ? "" : " · Choose dates for your quote"}</span>
      {stay && <span className="mt-1 block text-xs">{new Date(`${stay.start}T12:00:00Z`).toLocaleDateString('en-US', {month:'short',day:'numeric',timeZone:'UTC'})}–{new Date(`${stay.end}T12:00:00Z`).toLocaleDateString('en-US', {month:'short',day:'numeric',timeZone:'UTC'})} · {stay.nights} nights</span>}
    </p>
  );
}
